;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$timeout", "$element", "StateFactory"];
  angular.module('app.survey').component('barcodeScanner', {
    controller: Controller,
    templateUrl: 'barcode-scanner.html',
    bindings: {
      onScan: '&',
      onClose: '&',
    },
  })

  /* @ngInject */
  function Controller($scope, $timeout, $element, StateFactory) {
    var ctrl = this
    var codeReader = new ZXing.BrowserBarcodeReader()

    ctrl.$onInit = onInit
    ctrl.$onDestroy = onDestroy

    function onInit() {
      ctrl.state = new StateFactory(['loading', 'ready', 'error'])
      ctrl.state.loading()
      codeReader
        .listVideoInputDevices()
        .then(function(videoInputDevices) {
          $scope.$applyAsync(function() {
            if (!videoInputDevices.length) {
              ctrl.error = 'Camera not available'
              ctrl.state.error()
              return
            }
            ctrl.state.ready()
            $timeout(updateOverlay)
            codeReader.reset()
            codeReader
              .decodeOnceFromConstraints(
                {
                  video: {
                    facingMode: 'environment',
                    focusMode: 'continuous',
                    focusDistance: 0.33,
                  },
                  audio: false,
                },
                'barcodeScannerViewport'
              )
              .then(function(result) {
                $scope.$applyAsync(function() {
                  ctrl.onScan({ $value: result.text })
                })
              })
              .catch(function(err) {
                console.error(err)
              })
          })
        })
        .catch(function(err) {
          $scope.$applyAsync(function() {
            console.error(err)
            ctrl.error = 'Camera not available'
            ctrl.state.error()
          })
        })
    }

    function updateOverlay() {
      var viewportElem = $element[0].querySelector(
        '.barcode-scanner__container'
      )
      ctrl.vh = viewportElem.offsetHeight
      ctrl.vw = viewportElem.offsetWidth
      ctrl.mw = ctrl.vw
      ctrl.mh = 200
      ctrl.mhs = ctrl.vh / 2 - ctrl.mh / 2
      ctrl.lhs = ctrl.vh / 2
    }

    function onDestroy() {
      codeReader.reset()
    }
  }
})()
